import { useCurrentUser } from '../../../../../shared/features/session/components/CurrentUserProvider';

/** `workorder.manage` shows the controls that book, move and cancel; the server stays the authority, so this is UX only. */
export function useCanManageBookings(): boolean {
  const { state } = useCurrentUser();
  return state.status === 'authenticated' && state.user.permissions.includes('workorder.manage');
}
